var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import RadioCheckboxCard from '@marketing/components/funnel/FormFields/RadioCheckboxCard';
import ReceiptView from '@marketing/components/funnel/Receipt/Receipt';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import StripePaymentForm from '@marketing/profile/common/StripePaymentForm';
import { getFacebookPropsFromProfileData } from '@marketing/profile/trackers';
import { hasValidSummary } from '@marketing/profile/utils';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { formatFacebookServerProps, trackServerSideFacebookEvent } from '@trackers';
import { getGenderPronouns, isEligibleForHalfPortions } from '@utils/common_utils';
import { formatArrayCommaString } from '@utils/formatting_utils';
import { FREE_PRODUCT_DISPLAY_NAMES } from '@variables';
var showPortionsForm = function (pets) {
    return pets.every(function (pet) { return isEligibleForHalfPortions(pet.currentWeight, pet.weight); });
};
var PORTIONS_OPTIONS = [
    {
        id: 'full',
        label: 'Full Portions',
        description: '100% of their pre-portioned caloric and nutritional needs.',
        value: 1,
    },
    {
        id: 'half',
        label: 'Half Portions',
        description: 'Add 50% of our food to 50% of their current food.',
        value: 0.5,
    },
];
var PortionsBlock = function (_a) {
    var setDisableForm = _a.setDisableForm;
    var _b = useProfileContext(), profileData = _b.profileData, serverLoading = _b.serverLoading, saveProfile = _b.saveProfile, freeGiftWithPurchase = _b.freeGiftWithPurchase;
    var petNamesStr = profileData.pets.length < 3
        ? "".concat(formatArrayCommaString(profileData.pets.map(function (pet) { return pet.name; })), "\u2019s")
        : 'your dogs’';
    var handleInputChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var petsCopy, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDisableForm(true);
                    petsCopy = profileData.pets.map(function (pet) {
                        return __assign(__assign({}, pet), { quantityMultiplier: parseFloat(e.target.value) });
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveProfile({
                            pets: petsCopy,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error saving profile:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: showPortionsForm(profileData.pets) ? (_jsxs("form", __assign({ id: "portions-form", onSubmit: function (e) { return e.preventDefault(); } }, { children: [freeGiftWithPurchase && (_jsxs("p", { children: ["Enjoy a FREE bag of ", FREE_PRODUCT_DISPLAY_NAMES[freeGiftWithPurchase.productType], ' ', "with your first order."] })), _jsx("fieldset", __assign({ className: "grid grid-cols-1 gap-8", disabled: serverLoading }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-8" }, { children: [_jsxs("legend", { children: ["We offer 2 options for bigger dogs like", ' ', profileData.pets.length > 3
                                        ? 'yours'
                                        : formatArrayCommaString(profileData.pets.map(function (pet) { return pet.name; })), "."] }), _jsx("div", __assign({ className: "w-full md:w-fit mx-auto grid grid-cols-1 md:grid-cols-2 justify-items-center gap-6 md:gap-3" }, { children: PORTIONS_OPTIONS.map(function (option) {
                                    var optionId = "".concat(option.id, "-portions");
                                    return (_jsx("div", __assign({ className: "w-[240px] md:w-[270px] mx-auto" }, { children: _jsx(RadioCheckboxCard, __assign({ className: "p-4 md:p-6", checked: profileData.pets[0].quantityMultiplier === option.value, name: "gender", onInputChange: handleInputChange, optionId: optionId, type: "radio", value: option.value }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-2 text-left" }, { children: [_jsx("p", __assign({ className: "capitalize text-xs-head-m md:text-xs-head-d font-display" }, { children: option.label })), _jsx("p", __assign({ className: "text-sm-reg-m md:text-sm-reg-d" }, { children: option.description }))] })) })) }), optionId));
                                }) }))] })) }))] }))) : (_jsxs("p", { children: ["Your full meal plan will cover 100% of ", petNamesStr, " diet, which is an important investment in", ' ', profileData.pets.length > 1
                    ? 'their'
                    : getGenderPronouns(profileData.pets[0].gender).adjective, ' ', "all-around happiness and health.", freeGiftWithPurchase && (_jsxs(_Fragment, { children: [' ', "Enjoy a FREE bag of ", FREE_PRODUCT_DISPLAY_NAMES[freeGiftWithPurchase.productType], ' ', "with your first order."] }))] })) }));
};
var CheckoutForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), profileData = _a.profileData, setFacebookSubscribeEventProps = _a.setFacebookSubscribeEventProps, profileBasePath = _a.profileBasePath;
    var _b = useState(true), disableForm = _b[0], setDisableForm = _b[1];
    useEffect(function () {
        if (hasValidSummary(profileData)) {
            var props = getFacebookPropsFromProfileData(profileData);
            var formattedProps = formatFacebookServerProps(props);
            setFacebookSubscribeEventProps(formattedProps);
            trackServerSideFacebookEvent('AddPaymentInfo', profileData.uuid, props);
        }
    }, []);
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/address"), { viewTransition: true });
    };
    var formId = 'stripe-payment-form';
    return (_jsx(ProfileFormLayout, __assign({ formId: formId, disableNext: disableForm, handleClickPrevious: handleClickPrevious }, { children: _jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Summary" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 gap-16" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-1 gap-8 text-center" }, { children: [_jsx("h2", __assign({ className: "font-medium" }, { children: "Personalized Trial" })), _jsx(PortionsBlock, { setDisableForm: setDisableForm }), _jsxs("p", __assign({ className: "font-medium" }, { children: ["Delivering on ", profileData.deliveryDate] }))] })), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-16" }, { children: [_jsx(ReceiptView, { children: _jsx("h3", __assign({ className: "text-md-head-m md:text-md-head-d font-display text-center" }, { children: "Your order" })) }), _jsx(StripePaymentForm, { formId: formId, disableForm: disableForm, setDisableForm: setDisableForm })] }))] })) })) })));
};
export default CheckoutForm;
